import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ErrorsListRendererProps } from '../helpers';
import type { ColumnMapping } from 'venn-api';
import { logMessageToSentry } from 'venn-utils';
import NewErrorEditorRow from '../../../components/review-data/NewErrorEditorRow';

export const ErrorsListRenderer = ({
  errors,
  columns,
  editingSeriesId,
  metadata,
  updateErrors,
  isPrice,
}: ICellRendererParams & ErrorsListRendererProps) => {
  return (
    <div className="bg-venn-error/10 pl-[46px] pr-[101px]">
      <div className="py-[12px] text-[12px] text-venn-black font-bold border-0 border-b border-solid border-b-venn-grey-30">
        Edit values below to resolve, or adjust the investment’s return/price format to match uploaded data.
      </div>
      {errors
        .filter((e) => e.seriesId === editingSeriesId)
        .map((error) => {
          const { rowIndex, seriesId, value, date } = error;
          const column = columns.find((c: ColumnMapping) => c.seriesId === seriesId);
          if (column === undefined) {
            logMessageToSentry('Failed to log error editor row.');
            return null;
          }

          return (
            <NewErrorEditorRow
              key={`${rowIndex}-${column.origin.colIndex}`}
              cell={{
                row: rowIndex,
                column: column.origin.colIndex,
                value,
              }}
              date={date}
              valid={error.isValid}
              errors={error.errors.map((e) => metadata.errorTypes.find((t) => t.id === e)?.name ?? '')}
              onBlur={(newValue) => updateErrors(error, newValue)}
              isPrice={isPrice}
            />
          );
        })}
    </div>
  );
};
